import { apiFetchJson, type ApiRequestInit } from '@wundo/client/api.ts';
import type {
  OutreachQueueEntry,
  OutreachQueueKind,
} from '@wundo/shared/outreachQueue.ts';

export type { OutreachQueueEntry, OutreachQueueKind };

export interface OutreachQueueFilters {
  user_id?: string;
  organisation_id?: string;
  skill_id?: string;
  kind?: OutreachQueueKind;
  window_hours?: number;
  include_expired?: boolean;
}

/**
 * The skill work waiting to fire: recommendations, reminders and check-ins.
 *
 * Not paginated — the endpoint answers with everything inside the window, and
 * the window is the thing that keeps it small.
 */
export async function fetchOutreachQueue(
  filters: OutreachQueueFilters = {},
  init: ApiRequestInit = {},
): Promise<OutreachQueueEntry[]> {
  const params = new URLSearchParams();

  for (const [key, value] of Object.entries(filters)) {
    if (value !== undefined && value !== null && value !== '') {
      params.set(key, String(value));
    }
  }

  const suffix = params.toString() ? `?${params.toString()}` : '';
  const { data } = await apiFetchJson<{ data: OutreachQueueEntry[] }>(
    `/scheduled-tasks/skills-queue${suffix}`,
    init,
  );
  return data;
}
